import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetCategoryResponseBody } from '../CategoriesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseCategoryQueryValues = {
  appId: string;
  categoryId: string;
};

export const categoryQueryKeyFactory: IQueryKeyFactory<
  IUseCategoryQueryValues
> = (values) =>
  values && (['categories', values.appId, values.categoryId] as const);

export const useCategoryQuery = (
  values?: IUseCategoryQueryValues,
  options?: UseQueryOptions<IApiGetCategoryResponseBody, ApiError>,
): UseQueryResult<IApiGetCategoryResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: categoryQueryKeyFactory(values),
    queryFn: values
      ? () => api.categories.get(values.appId, values.categoryId)
      : undefined,
    ...options,
  });
};
